import { colors, variants } from '@opallabs/spectrum'

export { colors as Colors, variants as Variants }

// Colors is an import from a .json file and typed as a const object,
// so Typescript won't let us access it with a dynamic string property. This
// more general type will let us access it dynamically without strictly
// known names and variants.
type GeneralColorType = Record<string, Record<string, string | undefined>>

export function getColor(name: string, variant = 'base') {
  const baseColor = (colors as GeneralColorType)[name]

  if (!baseColor) {
    throw new Error(`No such color: ${name}`)
  }
  if (variants.indexOf(variant) < 0) {
    throw new Error(`No such variant: ${variant}`)
  }
  if (!baseColor[variant]) {
    return undefined
  }
  return baseColor[variant]
}

export default colors
